import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=08c39b5b&scoped=true&"
import script from "./thirdStep.vue?vue&type=script&lang=js&"
export * from "./thirdStep.vue?vue&type=script&lang=js&"
import style0 from "./thirdStep.vue?vue&type=style&index=0&id=08c39b5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c39b5b",
  null
  
)

export default component.exports